import { useMutation } from '@hooks/reactQuery';

import { getNetworkElementsValidationRules } from '@api/manageNetworkElementConfigurations';

import { EValidationRuleType, getTreeNodeValidation } from '@utils/treeValidation';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IValidationRuleDTO } from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';
import { TFlatTreeGetValidation } from '@components/common/FlatTree/interface';

import { EUserRoles } from '@enums/common';

import { NETWORK_ELEMENT_VALIDATION_RULES } from '@constants/queryKeys';

export interface IUseMutateNetworkElementValidationReturn {
	validationRules: TSelectOption[];
	getValidationRules: TFlatTreeGetValidation;
	isLoadingValidationRules: boolean;
}

export default function useMutateNetworkElementValidationRules(): IUseMutateNetworkElementValidationReturn {
	const {
		data,
		mutateAsync,
		isLoading,
	} = useMutation<any>({
		mutationKey: [NETWORK_ELEMENT_VALIDATION_RULES],
		mutationFn: async (dto: IValidationRuleDTO) => {
			const rules = await getNetworkElementsValidationRules(dto);
			const validations = getTreeNodeValidation(rules
				.filter(item => item.type.name !== EValidationRuleType.MANDATORY), !rules.length);

			return {
				rules,
				validations,
			};
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		requiredRoles: [EUserRoles.networkOperatorCmModuleEditor],
	});

	return {
		getValidationRules: mutateAsync,
		validationRules: data || [],
		isLoadingValidationRules: isLoading,
	};
}
